import { useLang } from '@/context/LanguageContext';

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <section
      className="relative w-full overflow-hidden py-10 md:py-14 border-y border-white/10 bg-[#0A0A0C]"
      aria-hidden
    >
      <div className="marquee-track font-display font-extrabold uppercase text-[10vw] md:text-[6vw] tracking-tighter leading-none text-white/[0.08]">
        {items.map((word, i) => (
          <span key={i} className="whitespace-nowrap flex items-center gap-16">
            {word}
            <span className="text-[#CCFF00]/70">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
};
